import { AosSeverity } from 'aos-services/src/services/common/types/AosSeverity'
import { TaskFormPayload } from 'aos-services/src/services/tasks/types/payload/TaskFormPayload'
import {
    TaskProcessType,
    taskProcessTypes,
    translateTaskProcessType,
} from 'aos-services/src/services/tasks/types/TaskProcessType'
import { ChipProcess } from 'aos-ui-universal'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { TaskOrTemplatePayload } from '../../../utils'
import { TaskFormField } from '../TaskFormField'

export const TaskProcessTypeField = () => {
    const { t: translate } = useTranslation()
    const { control } = useFormContext<TaskOrTemplatePayload>()
    const task = useWatch({ control }) as TaskFormPayload

    return (
        <Controller
            control={control}
            name='processType'
            render={({ field, fieldState }) => (
                <TaskFormField
                    label={translate('form.process-type.label', { ns: 'tasks' })}
                    required
                    error={
                        fieldState.error
                            ? translate('form.process-type.error', { ns: 'tasks' })
                            : undefined
                    }
                >
                    <div className='grid grid-cols-3 gap-2'>
                        {taskProcessTypes.map(p => (
                            <ChipProcess
                                key={p}
                                layout='horizontal-2-lines'
                                className='w-full'
                                label={translateTaskProcessType(translate)(p)}
                                isSelected={field.value === p}
                                isDisabled={
                                    p === TaskProcessType.Seasonal &&
                                    task.severity === AosSeverity.Emergency
                                }
                                onPress={() => field.onChange(p)}
                            />
                        ))}
                    </div>
                </TaskFormField>
            )}
        />
    )
}
